import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  isDownloadBoxVisible: true,
  isAppInstalled: null,
};

const AppSlice = createSlice({
  name: "app",
  initialState,
  reducers: {
    setIsDownloadBoxVisible: (state, action) => {
      state.isDownloadBoxVisible = action.payload;
    },
    setIsAppInstalled: (state, action) => {
      state.isAppInstalled = action.payload;
    },
  },
});

export const { setIsDownloadBoxVisible, setIsAppInstalled } = AppSlice.actions;
export default AppSlice.reducer;
